import InstallationTable from "components/Admin/Tables/InstallationTable";
import React, { memo } from "react";
import Widget from "../Widget";

interface Props {}

const PromoWidget: React.FC<Props> = () => {
  return (
    <Widget title="Цени за монтажи">
      <InstallationTable />
    </Widget>
  );
};

export default memo(PromoWidget);
